import React, { Component } from "react";
import { Row, Col, Card, Button, Container, Form } from "react-bootstrap";
import BreadcrumbsSection from "../breadcrumbs/BreadcrumbsSection";
import SelectDropDown from '../selectdropdown/SelectDropDown'
import { components } from 'react-select'
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { log } from "logrocket";
import { withApollo } from "react-apollo";
import CardLessDataTable from '../datatables/CardLessDataTableWithSearch';
import moment from "moment";
import DateBlock from '../home/DateBlock';
import './_offlineExams.scss';
import CardLessDataTableWithOutSearch from '../datatables/CardLessDataTableWithOutSearch';
import NotificationModal from './notificationModal';
import MultiSelect from "react-multi-select-component";
import PaginatedSortedTable from './PaginatedSortedTable';
import ExcelContainer from './excelContainer';





const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
            </components.DropdownIndicator>
        )
    );
};

const FETCH_GLOBALS = gql`
  query($institution_id: Int!) {
    globals(institution_id: $institution_id) {
        b_e_c_s_data {
            section_id
            class_id
            branch_id
            exam_id
          }
          educationalClasses {
            id
            class
          }
      globalPackages {
        id
        package_name
        exams_covered
      }
      globalCategories {
        id
        category_name
        package_id
      }
      classes {
        id
        class
      }
      exams {
        id
        exam
      }
      globalBranches {
        id
        branch_name
      }
      globalSections {
        id
        section_name
        branch_id
        category_id
        package_id
      }
      offlineExamSubjects{
        id
        subject
      }
    }
  }
`;

class OfflineExamResultsSection extends Component {
    constructor(props) {
        super(props)
        this.state = {
            defaultvalue: 0,
            branch: "",
            branchError: "",

            section: "",
            sectionError: "",

            class: "",
            classError: "",

            exam: "",
            examError: "",

            examName: "",
            examNameError: "",

            getOffExamResults: [],
            notificationModal: false,

            examDate: "",
            getExams: [],
            getClasses: [],
            getSections: [],
            sectionValue: [],
            getExamPapers: [],
            selectedExams: []
        }
    }

    handleInputChange = async (e) => {
        const name = e.target.name;
        const value = e.target.value;


        let getArray = [];

        if (name == "branch") {
            if (value != "0") {

                let uniqueExams = [...new Set(this.props.globals.globals.b_e_c_s_data.filter((item) => item.branch_id == value).map((item1) => item1.exam_id))].sort();

                uniqueExams.map((val) => {
                    let individualExamData = this.props.globals.globals.exams.find((item1) => item1.id == val);
                    const newObj = {
                        value: individualExamData.id,
                        label: individualExamData.exam
                    }
                    getArray.push(newObj);
                })

                this.setState({
                    branch: value,
                    branchError: "",
                    section: "",
                    sectionError: "",
                    class: "",
                    classError: "",
                    exam: "",
                    examError: "",
                    examName: "",
                    examNameError: "",
                    getOffExamResults: [],
                    getClasses: [],
                    getSections: [],
                    getExams: getArray,
                    sectionValue: [],
                    getExamPapers: [],
                    selectedExams: []
                })

            } else {

                this.setState({
                    branch: "",
                    branchError: "",
                    section: "",
                    sectionError: "",
                    class: "",
                    classError: "",
                    exam: "",
                    examError: "",
                    examName: "",
                    examNameError: "",
                    getOffExamResults: [],
                    getExams: [],
                    getClasses: [],
                    getSections: [],
                    sectionValue: [],
                    getExamPapers: [],
                    selectedExams: []
                })
            }
        }

        if (name == "exam") {

            if (value != "0") {


                let uniqueClasses = [...new Set(this.props.globals.globals.b_e_c_s_data.filter((item) => item.branch_id == this.state.branch && item.exam_id == value).map((item1) => item1.class_id))].sort();

                uniqueClasses.map((val) => {
                    let individualClassData = this.props.globals.globals.educationalClasses.find((item1) => item1.id == val);
                    const newObj = {
                        value: individualClassData.id,
                        label: individualClassData.class
                    }
                    getArray.push(newObj);
                })

                this.setState({
                    branchError: "",
                    section: "",
                    sectionError: "",
                    class: "",
                    classError: "",
                    exam: value,
                    examError: "",
                    examName: "",
                    examNameError: "",
                    getClasses: getArray,
                    getOffExamResults: [],
                    getSections: [],
                    sectionValue: [],
                    getExamPapers: [],
                    selectedExams: []
                })
            } else {
                this.setState({
                    branchError: "",
                    section: "",
                    sectionError: "",
                    class: "",
                    classError: "",
                    exam: "",
                    examError: "",
                    examName: "",
                    examNameError: "",
                    getOffExamResults: [],
                    getSections: [],
                    getClasses: [],
                    sectionValue: [],
                    getExamPapers: [],
                    selectedExams: []
                })

            }
        }

        if (name == "class") {

            if (value != "0") {

                let uniqueSections = [...new Set(this.props.globals.globals.b_e_c_s_data.filter((item) => item.branch_id == this.state.branch && item.exam_id == this.state.exam && item.class_id == value).map((item1) => item1.section_id))].sort();

                uniqueSections.map((val) => {
                    let individualSectionData = this.props.globals.globals.globalSections.find((item1) => item1.id == val);
                    const newObj = {
                        value: individualSectionData.id,
                        label: individualSectionData.section_name
                    }
                    getArray.push(newObj);
                })

                let sections = getArray.map((item) => item.value).toString();

                this.setState({
                    branchError: "",
                    section: sections,
                    sectionError: "",
                    class: value,
                    classError: "",
                    examError: "",
                    examName: "",
                    examNameError: "",
                    getSections: getArray,
                    getOffExamResults: [],
                    sectionValue: getArray,
                    selectedExams: []
                })

                const delay = (ms) => new Promise((r) => setTimeout(r, ms));
                await delay(100);

                this.getExamNames()

            } else {

                this.setState({
                    branchError: "",
                    section: "",
                    sectionError: "",
                    class: "",
                    classError: "",
                    examError: "",
                    examName: "",
                    examNameError: "",
                    getSections: [],
                    getOffExamResults: [],
                    sectionValue: [],
                    getExamPapers: [],
                    selectedExams: []
                })

            }

        }


        // if (name == "examName") {
        //     if (value != "0") {
        //         let date  = this.state.getExamPapers.find((item)=>item.exam_paper_id == value);

        //         this.setState({
        //             examName: value,
        //             examNameError: "",
        //             getOffExamResults: [],
        //             examDate : date.exam_date
        //         })
        //     } else {


        //         this.setState({
        //             examName: "",
        //             examNameError: "",
        //             getOffExamResults: [],
        //         })
        //     }
        // }
    };



    getOffExamResults = async () => {


        if (this.state.branch == "") {
            this.setState({ branchError: "Please select branch" })
            return ""
        }

        if (this.state.exam == "") {
            this.setState({ examError: "Please select exam" })
            return ""
        }

        if (this.state.class == "") {
            this.setState({ classError: "Please select class" })
            return ""
        }

        if (this.state.section == "") {
            this.setState({ sectionError: "Please select section" })
            return ""
        }
        if (this.state.examName == "") {
            this.setState({ examNameError: "Please select exam name" })
            return ""
        }

        this.setState({ loader: 1 });

        const result = await this.props.client.query({
            query: gql`
            query($offline_exam_paper_id:String,$section_id:String){
                getNewOffExamResults(offline_exam_paper_id:$offline_exam_paper_id,section_id:$section_id){
                    roll_no
                    student_name
                    section_name
                    branch_name
                    examWiseReport {
                      offline_exam_paper_id
                      Exam_Rank
                      Total_Marks
                      Accuracy
                      paper_name
                      subject_marks_rank {
                        subject_id
                        subject_name
                        subject_rank
                        subject_marks
                      }
                    }
                  }
            }
            `,
            variables: {
                offline_exam_paper_id: this.state.examName.toString(),
                section_id: this.state.section.toString()
            },
            fetchPolicy: 'network-only'
        })

        if (result.data.getNewOffExamResults.length > 0) {

            let results = result.data.getNewOffExamResults;
            let array = [];

            results.map((item) => {
                console.log("item", item.examWiseReport);
                let exam = item.examWiseReport.reduce((acc1, item1) => {
                    let subjects = item1.subject_marks_rank.reduce((acc2, item2) => {
                        acc2[`${item2.subject_name}_Marks`] = item2.subject_marks;
                        acc2[`${item2.subject_name}_Rank`] = item2.subject_rank;
                        return acc2;
                    }, {});

                    acc1[item1.paper_name] = { Accuracy: item1.Accuracy, Total_Marks: item1.Total_Marks, Exam_Rank: item1.Exam_Rank, ...subjects }
                    return acc1;
                }, {});
                array.push({ roll_no: item.roll_no, student_name: item.student_name, section_name: item.section_name, branch_name: item.branch_name, ...exam })
            })

            this.setState({ getOffExamResults: array, loader: 0 })
        } else {
            this.setState({ getOffExamResults: [], loader: 0 })
        }
    }

    showNotifyModal = () => {
        this.setState({
            notificationModal: true
        })
    }


    handleMultipleSelectInputChange = async (e, name) => {
        console.log("multi", e, name);

        if (name == "sections") {

            let section = "";
            if (e.length > 0) {
                section = e.map((item) => item.value).toString()
                this.setState({
                    sectionValue: e,
                    sectionError: "",
                    section,
                    getOffExamResults: [],
                    examName: "",
                    examNameError: "",
                    selectedExams: []
                });

                const delay = (ms) => new Promise((r) => setTimeout(r, ms));
                await delay(100);

                this.getExamNames()
            } else {
                this.setState({
                    sectionValue: [],
                    sectionError: "",
                    section: "",
                    getOffExamResults: [],
                    getExamPapers: [],
                    examName: "",
                    examNameError: "",
                    selectedExams: []
                });  
            }
        } else {

            let examName = "";
            if (e.length > 0) {
                examName = e.map((item) => item.value).toString()
                this.setState({
                    selectedExams: e,
                    examNameError: "",
                    examName,
                    getOffExamResults: [],
                });

            } else {
                this.setState({
                    selectedExams: [],
                    examNameError: "",
                    examName: "",
                    getOffExamResults: [],

                });
            }
        }


    }


    getExamNames = () => {

        if (this.props.getOfflineExamPapers != undefined && this.props.getOfflineExamPapers.length > 0) {
            let examPapers = [];
            let sections = this.state.section.split(',');
            console.log("sections", sections[0], this.props.getOfflineExamPapers);

            if (sections.length > 0 && sections[0] != "") {
                sections.map((item1) => {

                    this.props.getOfflineExamPapers.map((item) => {
                        if (item.branch_id == this.state.branch && item.class_id == this.state.class && item.exam_id == this.state.exam && item.section_id.includes(item1)) {
                            examPapers.push({ ...item })
                        }
                    })
                })


                let filterExamPapers = [];

                if (examPapers.length > 0) {

                    filterExamPapers = examPapers.filter((obj, index, self) => {
                        return self.findIndex(o => o.exam_paper_id === obj.exam_paper_id) === index;
                    });


                } else {
                    filterExamPapers = examPapers
                }

                let data = [];


                filterExamPapers.map((item) => {
                    let exam_date = moment.unix(item?.exam_date).format('DD-MM-YYYYY');
                    data.push({ value: item.exam_paper_id, label: `${item.paper_name}(${exam_date})`, exam_date:item.exam_date })
                })

                this.setState({
                    getExamPapers: data
                })

            } else {
                this.setState({
                    getExamPapers: []
                })
            }
            console.log("examPapers", examPapers);

        } else {
            this.setState({
                getExamPapers: []
            })
        }
    }

    render() {
        console.log("mahesh", this.state)

        const globals = this.props.globals;
        const loading1 = globals.loading;
        const error1 = globals.error;

        if (loading1) return null;

        if (error1 !== undefined) {
            alert("Server Error. " + error1.message);
            return null;
        }

        let globalsData = [];

        if (!loading1) {
            globalsData = this.props.globals.globals
        }


        let sectionSelectAll = true;
        let sectionlabelledby = "--Select Sections--";
        let sectiondisablesearch = false;
        if (this.state.getSections.length > 0) {
            sectionSelectAll = true;
            sectiondisablesearch = false;
        }
        else {
            sectiondisablesearch = true;
            sectionSelectAll = false;
            sectionlabelledby = "--Select Sections--"
        }

        let examNameSelectAll = true;
        let examNamelabelledby = "--Select Exam Name--";
        let examNamedisablesearch = false;
        if (this.state.getSections.length > 0) {
            examNameSelectAll = true;
            examNamedisablesearch = false;
        }
        else {
            examNamedisablesearch = true;
            examNameSelectAll = false;
            examNamelabelledby = "--Select Exam Name--"
        }

        return (
            <Container className="offline_results">
                <Row className="mt-5">
                    <Col sm={12}>
                        <Form>
                            <Form.Row>
                                <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectClass">
                                    <Form.Label className="text-uppercase">Branch</Form.Label>
                                    <Form.Control as="select" name="branch" onChange={this.handleInputChange} value={this.state.branch}>
                                        <option value={this.state.defaultvalue}>--Select Branch--</option>
                                        {globalsData.globalBranches.map(branchData => (
                                            <option value={branchData.id}>{branchData.branch_name}</option>
                                        ))}
                                    </Form.Control>
                                    <Form.Text className="form-text text-danger">
                                        {this.state.branchError}
                                    </Form.Text>
                                </Form.Group>

                                <Form.Group as={Col} lg={2} md={12} sm={12} controlId="Selectexam">
                                    <Form.Label className="text-uppercase">Exam</Form.Label>
                                    <Form.Control as="select" name="exam" onChange={this.handleInputChange} value={this.state.exam}>
                                        <option value={this.state.defaultvalue}>--Select Exam--</option>
                                        {this.state.getExams.map(item => (
                                            <option value={item.value}>
                                                {item.label}
                                            </option>
                                        ))}
                                    </Form.Control>
                                    <Form.Text className="form-text text-danger">
                                        {this.state.examError}
                                    </Form.Text>
                                </Form.Group>

                                <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectClass">
                                    <Form.Label className="text-uppercase">Class</Form.Label>
                                    <Form.Control as="select" name="class" onChange={this.handleInputChange} value={this.state.class}>
                                        <option value={this.state.defaultvalue}>--Select class--</option>
                                        {this.state.getClasses.map(classdata => (
                                            <option value={classdata.value}>{classdata.label}</option>
                                        ))}
                                    </Form.Control>
                                    <Form.Text className="form-text text-danger">
                                        {this.state.classError}
                                    </Form.Text>
                                </Form.Group>

                                <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectSection"  >
                                    <Form.Label className="text-uppercase">Section</Form.Label>
                                    <MultiSelect
                                        overrideStrings={{
                                            "allItemsAreSelected": "All Sections are selected.",
                                            "selectSomeItems": examNamelabelledby
                                        }
                                        }
                                        disableSearch={sectiondisablesearch}
                                        hasSelectAll={sectionSelectAll}
                                        options={this.state.getSections}
                                        value={this.state.sectionValue}
                                        onChange={(e) => this.handleMultipleSelectInputChange(e, "sections")}
                                        labelledBy={"Sections"}
                                    />
                                    <Form.Text className="form-text text-danger">
                                        {this.state.sectionError}
                                    </Form.Text>
                                </Form.Group>

                                <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectExam"  >
                                    <Form.Label className="text-uppercase">EXAM NAME</Form.Label>
                                    <MultiSelect
                                        overrideStrings={{
                                            "allItemsAreSelected": "All Exams are selected.",
                                            "selectSomeItems": sectionlabelledby
                                        }
                                        }
                                        disableSearch={examNamedisablesearch}
                                        hasSelectAll={examNameSelectAll}
                                        options={this.state.getExamPapers}
                                        value={this.state.selectedExams}
                                        onChange={(e) => this.handleMultipleSelectInputChange(e, "exams")}
                                        labelledBy={"exams"}
                                    />
                                    <Form.Text className="form-text text-danger">
                                        {this.state.examNameError}
                                    </Form.Text>
                                </Form.Group>
                                <Form.Group as={Col} lg={2} md={12} sm={12} controlId="Selectexam">
                                    <Button className="btn btn-success text-uppercase submit_btn" onClick={(e) => this.getOffExamResults()}>Get Results</Button>
                                </Form.Group>
                            </Form.Row>
                        </Form>
                    </Col>
                </Row>
                {
                    this.state.loader == 1 ?
                        (
                            <div className="spinner-border text-primary text-center loading-img-center" ></div>
                        )
                        :
                        ("")
                }

                {
                    this.state.getOffExamResults.length > 0 ?
                        (
                            <>
                                {
                                    this.state.selectedExams.length == 1 ? (
                                        <>
                                            <Row className="mt-5">
                                                <Col sm={3}>
                                                    <h5>Want to Notify Parents ?</h5>
                                                </Col>

                                                <Col sm={4}>
                                                    <Button className="report_btn" onClick={() => this.showNotifyModal()}>SEND NOTIFICATION</Button>
                                                </Col>
                                            </Row>
                                        </>
                                    ) : ""
                                }
                                <Row className="d-flex justify-content-end">
                                    <Col sm={2} >
                                        <ExcelContainer getOffExamResults={this.state.getOffExamResults} />
                                    </Col>
                                </Row>

                                <PaginatedSortedTable getOffExamResults={this.state.getOffExamResults} />
                            </>
                        )
                        :
                        ("")
                }

               <NotificationModal
                    show={this.state.notificationModal}
                    onHide={() => this.setState({
                        notificationModal: false })}
                    stateData={this.state}
                />
            </Container>
        )

    }
}

export default withRouter(withApollo(compose(
    graphql(FETCH_GLOBALS, {
        options: (props) => ({
            variables: {
                institution_id: parseInt(Cookies.get("institutionid")),
            },
        }),
        name: "globals",
    }),
)(OfflineExamResultsSection))
);
